(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('ProductDialogController', ProductDialogController);

    ProductDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Product','CommonService','$window','Upload','authExpiredInterceptor','$log'];

    function ProductDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Product,CommonService,$window,Upload,authExpiredInterceptor,$log) {
        var vm = this;
        vm.lstUnit = CommonService.query({masterurl:'unit'});
        vm.lstBudget = CommonService.query({masterurl:'budget'});
//        vm.lstGroupProduct = CommonService.query({masterurl:'product-group'});
        vm.product = entity;
        vm.listFile = vm.product.lstArchiveData;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.checkcreat = false;
        if (vm.product.productId != null || vm.product.productId != undefined) {
	       	vm.checkcreat = true;
	       	vm.product.isExit = true;
        }else{
    	   vm.product.isExit = false;
    	   vm.product.beginDate = new Date();
           vm.product.endDate = vm.product.beginDate;
           vm.product.status = "0";
        }
        if(vm.product.seriesIndicator == 1){
        	vm.statusSeries = true;
        }else{vm.statusSeries = false}
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
			$scope.clearMessage();
			vm.isSaving = true;
			$scope.loading = true;
			var data = [];
			vm.product.lstArchiveData = null;
			if(vm.statusSeries){
				vm.product.seriesIndicator = 1;
			}else{vm.product.seriesIndicator = 0;}

			if (vm.product.isExit == false) {
				if (vm.attachment != null && vm.attachment != undefined) {
					data['file'] = vm.attachment;
					data['productItemDto'] = new Blob( [ JSON.stringify(vm.product) ], { type : "application/json" });
					Upload.upload( { url : GLOBAL_URL + 'api/master/save-product-file?_csrf=' + authExpiredInterceptor.getCSRF(), data : data
					}).then( function(resp) {
						$log.debug('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
						// vm.checkCreate = true;
						$scope.loading = false;
						$scope.$emit('masterApp:productUpdate', resp);
						$uibModalInstance.close(resp);
						vm.isSaving = true;
						editForm.$setPristine();
						editForm.$setUntouched();
					},
					function(resp) {
						$log.debug('Error status: ' + resp.status);
						vm.isSaving = false;
						$scope.loading = false;
						// vm.checkCreate = false;
					},
					function(evt) {
						$scope.loading = false;
						var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
						$log.debug('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
					});
				} else {
					Product.save(vm.product, function(result) {
						$scope.$emit('masterApp:productUpdate', result);
						$uibModalInstance.close(result);
						$scope.loading = false;
						vm.isSaving = true;
					}, function(error) {
						vm.isSaving = false;
						$scope.loading = false;
					});
				}
			} else {
				if (vm.attachment != null && vm.attachment != undefined) {
					// if (editForm.file.$valid && vm.attachment) {
					data['file'] = vm.attachment;
					data['productItemDto'] = new Blob([ JSON.stringify(vm.product) ], { type : "application/json"});
					// }
					Upload.upload( { url : GLOBAL_URL + 'api/master/update-product-file?_csrf=' + authExpiredInterceptor.getCSRF(), data : data })
					.then( function(resp) {
					$log.debug('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
					// vm.checkCreate = true;
					$scope.loading = false;
					$scope.$emit('masterApp:productUpdate', resp);
					$uibModalInstance.close(resp);
					vm.isSaving = true;
					editForm.$setPristine();
					editForm.$setUntouched();
					},
					function(resp) {
						$log.debug('Error status: ' + resp.status);
						$scope.loading = false;
						vm.isSaving = false;
						// vm.checkCreate = false;
					},
					function(evt) {
						$scope.loading = false;
						var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
						$log.debug('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
					});
				} else {
					Product.update(vm.product, function(result) {
						$scope.$emit('masterApp:productUpdate', result);
						$uibModalInstance.close(result);
						vm.isSaving = true;
						$scope.loading = false;
					}, function(error) {
						vm.isSaving = false;
						$scope.loading = false;
					});
				}
			}
		}

        function onSaveSuccess (result) {
            $scope.$emit('masterApp:productUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = true;
        }

        function onSaveError () {
            vm.isSaving = false;
        };
        function onSaveError () {
            vm.isSaving = false;
        }
        vm.openFromDate = function() {
    		vm.popupFromDate.opened = true;
    	};
    	vm.openToDate = function() {
    		vm.popupToDate.opened = true;
    	};
    	$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd/MM/yyyy',
    			'shortDate' ];
    	$scope.format = $scope.formats[2];
    	$scope.altInputFormats = [ 'dd/MM/yyyy' ];

    	vm.popupFromDate = {
    		opened : false
    	};

    	vm.popupToDate = {
    		opened : false
    	};
    	if(vm.product!=undefined){
			vm.dateEndOptions = {
					minDate : vm.product.beginDate,
					maxDate : new Date()
			};
		}
    	
    	vm.dateOptions = {
    		    maxDate: new Date()
    	};
    	vm.validateDates =function () {
    		vm.dateEndOptions = {
					minDate : vm.product.beginDate,
					maxDate : new Date()
			};
	    };
	    	vm.download=function(fileAttachment) {
				//danh cho ie
				if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for IE browser
						 var blob=new Blob([fileAttachment], { type: fileAttachment.type });
						 window.navigator.msSaveBlob(blob, fileAttachment.name);
				}else{
						//truong hop file luu tam tren man hinh
						var blob=new Blob([vm.attachment], { type: fileAttachment.type });
						var url = $window.URL || $window.webkitURL;
					    var aTag = document.createElement("a");
					    aTag.style.cssText = "display: none";
			    		/*aTag.style = "display: none";*/
			    		aTag.href = url.createObjectURL(blob);
			    		aTag.download = fileAttachment.name ==undefined? fileAttachment.name : fileAttachment.name;
			    		aTag.click();
				}
			};
			
			vm.downloadFileHistory=function(item) {
				//danh cho ie
				if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for IE browser
						var byteCharacters = atob(item.content);
						var byteNumbers = new Array(byteCharacters.length);
						for (var i = 0; i < byteCharacters.length; i++) {
						    byteNumbers[i] = byteCharacters.charCodeAt(i);
						}
						var byteArray = new Uint8Array(byteNumbers);
						var blob=new Blob([byteArray], { type: item.dataType+';charset=utf-8' });
						window.navigator.msSaveBlob(blob, item.dataName);
				}else{
					//truong hop file da luu duoi database
						var byteCharacters = atob(item.content);
						var byteNumbers = new Array(byteCharacters.length);
						for (var i = 0; i < byteCharacters.length; i++) {
						    byteNumbers[i] = byteCharacters.charCodeAt(i);
						}
						var byteArray = new Uint8Array(byteNumbers);
						var blob=new Blob([byteArray], { type: item.dataType+';charset=utf-8' });
					    var url = $window.URL || $window.webkitURL;
					    var aTag = document.createElement("a");
					    aTag.style.cssText = "display: none";
			    		aTag.href = url.createObjectURL(blob);
			    		aTag.download =item.dataName;
			    		aTag.click();
					}
			};


    }
})();
